import React from "react"

const Loading = () => {
  return (
    <div className="loading" title="loading items">
      <div className="loading-spinner"></div>
    </div>
  )
}

export default Loading
